import * as React from 'react';
import { EStatus, IReferralItem } from '../../repositories/cpd/entities/v1_get_referrals_listing/ReferralItem';
import { UIHeading3, UIText1, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';
import cx from 'clsx';

interface IReferralsListItemProps extends IReferralItem {
  headingIcon: React.ReactNode;
  headingStatusName: React.ReactNode;
  onClick: () => void;
}

export const ReferralsListItem: React.FC<IReferralsListItemProps> = ({
  name,
  phone,
  status,
  date,
  headingIcon,
  headingStatusName,
  onClick,
}) => {
  return (
    <div className={styles['item']} onClick={onClick}>
      <div
        className={cx(
          styles['heading'],
          status === EStatus.Paid && styles['status-paid'],
          status === EStatus.Completed && styles['status-completed'],
          status === EStatus.Rejected && styles['status-rejected'],
          status === EStatus.InProgram && styles['status-in-program'],
        )}
      >
        <div className={styles['heading-status']}>
          {headingIcon} {headingStatusName}
        </div>
        <div>
          <UIText2 color="text-secondary-default">{date}</UIText2>
        </div>
      </div>

      <div className={styles['info']}>
        <UIHeading3 color="text-primary-default">{name}</UIHeading3>
        <UIText1 color="text-secondary-default">{phone}</UIText1>
      </div>
    </div>
  );
};
